import { useState } from "react";

import { makePostApiCall, makePutApiCall } from "../../../shared/makeApiCall";
import ManufacturersForm from "../../../components/forms/setup/manufacturers/ManufacturersForm";
import DeleteConfirmationForm from "../../../components/forms/DeleteConfirmationForm";
import { SnackbarData, SnackbarType } from "../../../components/Snackbar";
import { generateUniqueNumber } from "../../../shared/utility";

export function ManufacturersViewModel(logout, addSnackbar) {
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(false);
  const [manufacturers, setManufacturers] = useState({ data: [] });
  const [taxRatesOptions, setTaxRatesOptions] = useState([]);
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });

  const getManufacturers = async function (search, page) {
    setLoading(true);
    const payload = {
      page: page,
      search: search,
    };
    let callResult = await makePostApiCall(`manufacturers`, payload);
    setLoading(false);
    if (callResult.success) {
      setManufacturers(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const getTaxRatesForDropdown = async function () {
    let callResult = await makePostApiCall(`taxRatesForDropdown`, {});

    if (callResult.success) {
      setTaxRatesOptions(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const createManufacturer = async function (values) {
    const payload = {
      name: values.name,
      taxes: values.taxes || [],
    };
    let callResult = await makePostApiCall("createManufacturer", payload);

    if (callResult.success) {
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          "Supplier added",
          SnackbarType.Success,
        ),
      );
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getManufacturers("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const updateManufacturer = async function (manufacturer, values, index) {
    const payload = {
      id: manufacturer.id,
      name: values.name,
      taxes: values.taxes || [],
    };
    let callResult = await makePutApiCall(
      `manufacturer/${manufacturer.id}`,
      payload,
    );

    if (callResult.success) {
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          "Supplier updated",
          SnackbarType.Success,
        ),
      );
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getManufacturers("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const openAddManufacturerSlideOver = () => {
    setSlideOver({
      childComponent: (
        <ManufacturersForm
          isEdit={false}
          setOpen={setSlideOver}
          actionCall={createManufacturer}
          taxRatesOptions={taxRatesOptions}
        />
      ),
      open: true,
    });
  };

  const fetchManufacturerDetails = async function (manufacturer, index) {
    let callResult = await makePostApiCall(
      `manufacturer/${manufacturer.id}`,
      {},
    );

    if (callResult.success) {
      setSlideOver({
        childComponent: (
          <ManufacturersForm
            manufacturer={callResult.data}
            index={index}
            isEdit={true}
            setOpen={setSlideOver}
            actionCall={updateManufacturer}
            taxRatesOptions={taxRatesOptions}
          />
        ),
        open: true,
      });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const deleteManufacturer = async function (id, index) {
    setLoading(true);

    let callResult = await makePostApiCall(`deleteManufacturer/${id}`, {});
    setLoading(false);
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });
      getManufacturers(null, 0);
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          callResult.data.message,
          SnackbarType.Success,
        ),
      );
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const askDeleteManufacturer = function (manufacturer, index) {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          confirmAction={() => deleteManufacturer(manufacturer.id, index)}
          message={`Are you sure you want to delete ${manufacturer.name}?`}
          setOpen={setEmptyModelOpen}
        />
      ),
      open: true,
    });
  };

  return {
    askDeleteManufacturer,
    emptyModal,
    setEmptyModelOpen,
    getManufacturers,
    getTaxRatesForDropdown,
    loading,
    manufacturers,
    openAddManufacturerSlideOver,
    setSlideOver,
    slideOver,
    fetchManufacturerDetails,
  };
}
